import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, MenuItem
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import {useSelector} from "react-redux";

const StyledDialogContent = styled(DialogContent)({
  backgroundColor: '#fdfdfd',
  borderTop: '1px solid #eee',
  borderBottom: '1px solid #eee'
})

const DialogForm = styled('div')({
  padding: '10px 0'
})

const DialogTextField = styled(TextField)({
  backgroundColor: '#fff',
  margin: '10px 0'
})

const initData = {
  groupId: '',
  groupName: '',
  companyCode: '',
  companyName: '',
  companyIdentify: '',
  managerList: [{
    name: '',
    phone: '',
    email: '',
    ip: ''
  },
  {
    name: '',
    phone: '',
    email: '',
    ip: ''
  }]
}

const displayInfo = {
  groupId: {
    type: 'selectKey',
    value: '대주주아이디',
  },
  groupName: {
    type: 'select',
    key: 'groupId',
    value: '대주주',
    required: true,
  },
  companyCode: {
    type: 'text',
    value: '회사코드',
    required: true,
  },
  companyName: {
    type: 'text',
    value: '회사명',
    required: true,
    isEdit: true,
  },
  companyIdentify: {
    type: 'text',
    value: 'ID',
    required: true,
    isEdit: true,
  },
  name: {
    type: 'text',
    value: '담당자',
    required: true,
    isEdit: true,
  },
  phone: {
    type: 'text',
    value: '전화번호',
    required: true,
    isEdit: true,
  },
  email: {
    type: 'text',
    value: '이메일',
    required: true,
    isEdit: true,
  },
  ip: {
    type: 'text',
    value: 'IP',
    required: false,
    isEdit: true,
  }
}

const Modal = ({
  data,
  open,
  completeModal
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [ form, setForm ] = useState(initData)
  const [ isConfirm, setIsConfirm ] = useState(false)
  const {
    groupList,
  } = useSelector(store => store.companyAdmin)

  // const handleClickOpen = () => {
  //   completeModal(true, data)
  //   setForm(initData)
  // }

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return
    }
    setIsConfirm(false)
    completeModal(false)
    setForm(initData)
  }

  const handleChangeData = (key, value, idx, subKey) => {
    const updateForm = JSON.parse(JSON.stringify(form))
    if (typeof idx === 'number') {
      if (updateForm[key].length === idx) {
        updateForm[key][idx] = {
          companyId: data.companyId,
          name: '',
          phone: '',
          email: '',
          ip: ''
        }
      }
      updateForm[key][idx][subKey] = value
    } else {
      updateForm[key] = value
    }
    setForm(updateForm)
  }

  const handleUpdateData = () => {
    setIsConfirm(true)
    const { groupId, companyName, companyCode, managerList, companyIdentify } = form
    const { name, phone, email } = managerList[0]

    if (groupId && companyName && companyIdentify && companyCode && name && phone && email) {
      completeModal(true, form)

      setIsConfirm(false)
      setForm(initData)
    }
  }

  useEffect(() => {
    setForm(data || initData)
  }, [ data ])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="관리자 등록/변경"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle id="responsive-dialog-title">
        관리자 {data ? '변경' : '등록'}
      </DialogTitle>
      <StyledDialogContent>
        <DialogForm>
          {
            Object.keys(initData).map((key, index) => {
              return (
                <React.Fragment key={index}>
                  {
                    initData[key].length ? initData[key].map((data, idx) => {
                      return Object.keys(data).map((subKey, i) => {
                        const isRequired = !idx && subKey !== 'ip'
                        return (
                          <DialogTextField
                            label={`${displayInfo[subKey].value} ${idx + 1}`}
                            value={form[key][idx] && form[key][idx][subKey]}
                            fullWidth
                            key={`${index}-${idx}-${i}`}
                            required={isRequired}
                            error={isConfirm && isRequired && !(form[key][idx] && form[key][idx][subKey])}
                            size={'small'}
                            onChange={(e) => handleChangeData(key, e.target.value, idx, subKey)}
                          />
                        )
                      })
                    }) : (
                      displayInfo[key].type === 'text' ?
                        (
                          <DialogTextField
                            label={displayInfo[key].value}
                            value={form[key]}
                            fullWidth
                            autoFocus={!index}
                            error={isConfirm && (displayInfo[key].required && !form[key])}
                            required={displayInfo[key].required}
                            disabled={data && !displayInfo[key].isEdit}
                            size={'small'}
                            onChange={(e) => handleChangeData(key, e.target.value)}
                          />
                        ) : (
                          displayInfo[key].type === 'select' &&
                            <DialogTextField
                              label={displayInfo[key].value}
                              value={form[displayInfo[key].key]}
                              fullWidth
                              select
                              required={displayInfo[key].required}
                              disabled={data && !displayInfo[key].isEdit}
                              error={isConfirm && (displayInfo[key].required && !form[displayInfo[key].key])}
                              autoFocus={!index}
                              size={'small'}
                              onChange={(e) => handleChangeData(displayInfo[key].key, e.target.value)}
                            >
                              {
                                groupList && groupList.map(group => (
                                  <MenuItem key={group.groupId} value={group.groupId}>
                                    {group.groupName}
                                  </MenuItem>
                                ))
                              }
                            </DialogTextField>
                        )
                    )
                  }
                </React.Fragment>
              )
            })
          }
        </DialogForm>
      </StyledDialogContent>
      <DialogActions>
        <Button variant="contained" disableElevation onClick={handleUpdateData}>
          {data ? '변경' : '등록'}
        </Button>
        <Button onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Modal